const DOMAIN_REGEXP = /https?:\/\/[^/]+\//gi;

const hasUrlOrigin = (url) => (url ? !!url.match(DOMAIN_REGEXP) : false);

export default hasUrlOrigin;
